import React from "react";

const PopupLayout = (props) => {
  return <div style={{ padding: "22px", backgroundColor: "rgb(245, 245, 245)" }}>{props.children}</div>;
};

export default PopupLayout;
